export const meta = {
  title: '服务条款 | PhotoCraft ArtCraft AI',
  description:
    '使用 photocraftartcraft.com（开源编辑器 PhotoCraft 与 VectorCraft 的独立指南站）的条款。',
  updated_at: '2026-10-22',
};

## 关于本站

photocraftartcraft.com（下称"本站"）是由 PhotoCraft ArtCraft AI 运营的独立 PhotoCraft 与 VectorCraft 指南站。使用本站即表示你同意本条款，如不同意请勿使用。

## 无关联声明

本站与 ArtCraft、Storyteller、Adobe 均无关联，也未获得其认可或赞助。PhotoCraft、VectorCraft 和 ArtCraft 是其各自所有者的商标，Adobe、Photoshop 和 Illustrator 是 Adobe Inc. 的商标。本站使用这些名称仅用于介绍和对比软件。

## 关于 PhotoCraft 与 VectorCraft 软件

PhotoCraft 和 VectorCraft 由 ArtCraft 团队开发，通过官方 GitHub Releases 以 MIT 或 Apache-2.0 许可证发布。你使用它们（包括本站托管的在线版）时适用的是该许可证，而不是本条款。两者目前都是早期 Alpha 软件，由作者按"现状"提供。正式使用前请备份好你的作品；使用在线版时请记得经常保存。

## 信息准确性

我们会尽量保持下载链接、安装步骤、功能列表和对比内容准确及时，但软件和价格变化很快，无法保证所有细节都是最新的。做决定前请查看各页面提供的官方链接。

## 账户

如果你注册了账户，请妥善保管登录信息，账户下的操作由你负责。滥用本站的账户可能会被暂停。

## 使用规范

请勿攻击、压垮、以滥用的频率抓取或试图破坏本站，也不得将本站用于任何违法用途。

## 责任限制

本站按"现状"提供，不作任何保证。在法律允许的范围内，对因使用本站或本站链接的第三方软件造成的任何损失，我们不承担责任。

## 条款变更与联系

我们可能会更新本条款，页面顶部的日期表示最后更新时间。如有疑问请联系：[support@photocraftartcraft.com](mailto:support@photocraftartcraft.com)。
